// NOTES
// - the time value is passed to and from the component as a String of the format "HH:mm:ss"
// - momentjs is only used to ease the generation of available dropdown options

import moment from "moment-timezone";
import React, { PureComponent } from "react";
import { PropTypes } from "prop-types";
import { Field } from "formik";

import FormikSemanticDropdown from "../../forms/formik/FormikSemanticDropdown.jsx";

class FormikSimpleTimeDropdown extends PureComponent {
  static propTypes = {
    form: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    required: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    timezone: PropTypes.string.isRequired,

    min: PropTypes.string,
    max: PropTypes.string,
    max: PropTypes.number,
    label: PropTypes.string,
    placeholder: PropTypes.string,

    onChange: PropTypes.func.isRequired,
    time: PropTypes.string
  };

  static defaultProps = {
    required: false,
    disabled: false,
    timezone: "UTC"
  };

  // default component values
  // the min/max values are chosen arbitrarily for convenience
  static defaults = {
    interval: 15,
    min: moment.tz("2018-02-02", "UTC"),
    max: moment.tz("2018-02-03", "UTC"),
    time: "09:00:00"
  };

  // -- HANDLERS -- //

  onTimeChange = (event, data) => {
    this.props.onChange(data.value);
  };

  // -- RENDER -- //

  getTimeOptions = () => {
    let { interval, timezone, min, max } = this.props;

    interval = interval || FormikSimpleTimeDropdown.defaults.interval;
    min = min || FormikSimpleTimeDropdown.defaults.min.clone();
    max = max || FormikSimpleTimeDropdown.defaults.max.clone();

    let time = min.clone();
    let times = [];

    const offset = moment.tz(timezone).utcOffset();

    while (time.unix() < max.unix()) {
      const text = time.format("HH:mm");
      const value = time.clone().subtract(offset, "m").format("HH:mm:ss");

      times.push({ text, value });

      // step
      time.add(interval, "m");
    }

    return times;
  };

  render() {
    const {
      field,
      label,
      placeholder,
      required,
      readOnly,
      disabled,
      apiErrors
    } = this.props;

    return (
      <Field
        name={field.name}
        placeholder={placeholder}
        label={label}
        required={required}
        readOnly={readOnly}
        disabled={disabled}
        fluid
        search
        selection
        options={this.getTimeOptions()}
        onChange={this.onTimeChange}
        apiErrors={apiErrors}
        component={FormikSemanticDropdown}
      />
    );
  }
}

export default FormikSimpleTimeDropdown;
